import {adminHttp} from "~/Admin/services/http";

export const loadLanguagesAction = () => async (dispatch) => {

    const response = await adminHttp.get('/languages');

    dispatch({
        type: 'LOAD_LANGUAGES',
        payload: response.data || null
    });
};

export const loadTranslationSections = () => async (dispatch) => {

    const response = await adminHttp.get('/translation-sections');

    dispatch({
        type: 'LOAD_TRANSLATION_SECTIONS',
        payload: response.data
    })
}